import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { Button, Stack, Typography, useTheme } from '@mui/material';

import { useUserContext } from 'src/components/app/context/UserContext';

import { styles } from './index.styles';

const UserNavigation: FC = () => {
  const { triggerAutoLogout, user } = useUserContext();
  const { colors } = useTheme();
  const { t } = useTranslation('common');

  return !user ? null : (
    <Stack direction="row" spacing={1}>
      <Stack pb={1.5} spacing={0.25}>
        <Typography variant="caption" color={colors.secondary[700]} mb={0.5}>
          {t('user')}:
        </Typography>
        <Typography sx={styles.userName} variant="button2">
          {user.first_name} {user.last_name}
        </Typography>
      </Stack>
      <Stack direction="row" pb={0.25}>
        <Button
          variant="text"
          endIcon={<LogoutRoundedIcon />}
          onClick={triggerAutoLogout}
          sx={styles.logoutButton}
        >
          {t('logout')}
        </Button>
      </Stack>
    </Stack>
  );
};

export default UserNavigation;
